import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SCheckboxFilter = styled.div`
  margin-right: 40px;

  ${setFlexDFFDC};
`;
